import { DepartmentType } from '@/types/questions'

export const endpointRequiresStartDate = (departmentType?: DepartmentType): boolean =>
    departmentType !== DepartmentType.OPERATIONS
